// Get Promotions
export const GET_PROMOTIONS_REQUEST = 'GET_PROMOTIONS_REQUEST';
export const GET_PROMOTIONS_DONE = 'GET_PROMOTIONS_DONE';
export const GET_PROMOTIONS_FAILED = 'GET_PROMOTIONS_FAILED';
export const GET_PROMOTIONS_RESET = 'GET_PROMOTIONS_RESET';

// Operations
export const PROMOTIONS_SET_PAGE = 'PROMOTIONS_SET_PAGE';